<template>
    <div>
        <div class="action-header">
            <div class="search-container">
                <div class="search-input">
                    <v-text-field
                        v-model="search"
                        prepend-inner-icon="search"
                        :placeholder="this.$vuetify.lang.t('$vuetify.positions.searchText')"
                        solo
                        height="40px"
                        @keyup.enter="searchPosition()">
                    </v-text-field>
                </div>

                <div class="ml-3">
                    <v-btn
                        height="40px"
                        color="primary"
                        outlined
                        @click="searchPosition()">
                        {{ $vuetify.lang.t('$vuetify.positions.search') }}
                    </v-btn>
                </div>
            </div>
        </div>
        <v-card class="content-container">
            <v-data-table
                :footer-props="{
                    'items-per-page-options': [10, 20, 30, 50, 100]
                }"
                @page-count="pageCount = $event"
                :page.sync="page"
                :headers="headers"
                :options.sync="options"
                :server-items-length="totalPositions"
                :items="positions"
                :loading="loading">
            </v-data-table>
        </v-card>
        <div class="pt-2 paginator-box">
            <div>
                <v-pagination v-model="page" :length="pageCount"></v-pagination>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Positions',

    data () {
        return {
            search: '',
            pageCount: 1,
            page: 1,
            options: {},
            loading: false,
            totalPositions: 0,
            positions: []
        }
    },

    computed: {
        headers () {
            return [
                { text: this.$vuetify.lang.t('$vuetify.positions.positionId'), value: 'position_id', width: '20%' },
                { text: this.$vuetify.lang.t('$vuetify.positions.name'), value: 'name', width: '17%' },
                { text: this.$vuetify.lang.t('$vuetify.positions.shortName'), value: 'short_name', width: '40%' }
            ]
        }
    },

    methods: {
        async searchPosition () {
            this.options.page = 1
            await this.getPositions()
        },

        async getPositions () {
            this.loading = true
            const { sortBy, sortDesc, page, itemsPerPage } = this.options

            let url = `positions?page=${page}&itemsPerPage=${itemsPerPage}`

            if (sortBy[0]) {
                url += `&sortBy=${sortBy[0]}`
            }

            if (sortDesc[0]) {
                url += `&sortDesc=${sortDesc[0]}`
            }

            if (this.search) {
                url += `&search=${this.search}`
            }

            const res = await this.axios.get(url)
            if (res && res.data && res.data.status === 'ok') {
                this.positions = res.data.data
                this.totalPositions = res.data.total
                this.loading = false
            }
        }
    },

    watch: {
        options: {
            async handler () {
                await this.getPositions()
            },
            deep: true
        },
        '$vuetify.lang.current': {
            handler: async function (after, before) {
                await this.getPositions()
            },
            deep: true
        }
    }
}
</script>

<style lang="scss" scoped>
::v-deep .v-input__control > .v-input__slot {
    min-height: auto !important;
    display: flex !important;
    align-items: center !important;
    box-shadow: none !important;
    border: 1px solid #a8a8a8 !important;
}
</style>
